import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Grid,
  TextareaAutosize,
  FormControl,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../devoteeManagement/devoteeManagement.module.scss";
import {
  CommonButton,
  CustomInputLabel,
  CommonOutlinedButton,
  CustomMenuItem,
  CustomTextFeildPooja,
  CustomSelectforPooja,
} from "../../common/StyledComponents/StyledFields";
import {
  apiRequest,
  catchErrorMessageHandler,
  getUserName,
  getUserRoleId,
  getaccessToken,
  separateDateAndTime,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { poojaHallRentListProps } from "../../../infrastructure/GlobalContextProvider";
import Pagination from "../../common/pagination/pagination";
import { isEmpty, isNil, isNull } from "lodash";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ErrorPopup from "../../common/ErrorPopup";
import constants from "../../../config/constants.json";
import { ASP_BASE_URL } from "../../../config/apiUrl";
import { useNavigate } from "react-router-dom";
import FinalSettlementComponent from "../../hallContractForm/formReconsilationPage";
import RefundToDevotee from "./RefundToDevotee";
import SuccessPopup from "../../devotee/donation/successPopup";
import { ClipLoader } from "react-spinners";
import { addPoojaDetails, fetchPriestList } from "../../../features/poojaBookingSlice";
import { useAppDispatch } from "../../../app/hook";
import PriestWeeklySchedule from "../priestSchedule/priestWeeklySchedule";
import { addHallBookingDetails, fetchHallList } from "../../../features/hallBookingSlice";
import HallSchedule from "../HallSchedule/HallSchedule";

const DevoteePoojaHallRequest = (): JSX.Element => {
  const [hallContractId, setHallContractId] = useState(0);
  const [contractId, setContractId] = useState(0);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [buttonDisable, setButtonDisable] = useState(true);
  const [selectedRows, setSelectedRows] = useState<poojaHallRentListProps[]>(
    []
  );
  const [requestData, setRequestData] = useState<poojaHallRentListProps[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [reason, setReason] = useState<string>("");
  const [selectedTypeName, setSelectedTypeName] = useState<string>("");
  const [devoteeName, setDevoteeName] = useState<string>("");
  const [statusValue, setStatusValue] = useState<string | number | null>(0);
  const [usernameValue, setUsernameValue] = useState<string | null>(null);
  const [requestTypeValue, setRequestTypeValue] = useState<string | null>(null);
  const [pageSize, setPageSize] = useState<number>(25);
  const [firstname, setfirstname] = useState<string | null>(null);
  const [lastname, setLastname] = useState<string | null>(null);
  const [showReconsilation, setShowReconsilation] = useState(false);
  const [showRefundToDevotee, setShowRefundToDevotee] = useState(false);
  const [selectedHallRequest, setSelectedHallRequest] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showPriestSchedulingScreen, setShowPriestSchedulingScreen] = useState<boolean>(false)
  const [showHallSchedulingScreen, setShowHallSchedulingScreen] = useState<boolean>(false)
  const dispatch = useAppDispatch();

  const requestTypeList = [
    { id: "", label: "All" },
    { id: "P", label: "Pooja" },
    { id: "E", label: "Hall" },
  ];
  const statusList = [
    {
      id: 0,
      label: "All",
    },
    {
      id: 1,
      label: "Pending",
    },
    {
      id: 2,
      label: "Confirmed",
    },
    {
      id: 3,
      label: "Booked",
    },
    {
      id: 4,
      label: "Cancel Request",
    },
    {
      id: 5,
      label: "Cancelled",
    },
    {
      id: 7,
      label: "Form Filled",
    },
    {
      id: 8,
      label: "Form to be Signed",
    },
    {
      id: 9,
      label: "Form Signed",
    },
    {
      id: 12,
      label: "Settlement Pending",
    },
    {
      id: 11,
      label: "Final Payment Due & Contract",
    },
  ];
  const itemsPerPageList = [25, 30, 35, 40, 45, 50];
  const navigate = useNavigate();

  useEffect(() => {
    getApiCall();
  }, [
    pageNumber,
    statusValue,
    usernameValue,
    requestTypeValue,
    pageSize,
    firstname,
    lastname,
  ]);

  const getApiCall = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.findAllPoojaHallRequests,
      includeToken: true,
      params: {
        sortBy: "bookingDate",
        page: pageNumber - 1,
        size: pageSize,
        direction: "asc",
        username: usernameValue,
        requestType: requestTypeValue,
        status: Number(statusValue) === 0 ? "" : statusValue,
        firstname: firstname,
        lastname: lastname,
      },
    })
      .then((res) => {
        setRequestData(res.data.content);
        setTotalRecords(res.data.totalElements);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const apiCall = (rowData: any) => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${rowData.id}/contracts/${rowData.hallContractFormId}`,
      includeToken: true,
    })
      .then((res) => {
        navigate(
          `/hallForm?username=${rowData.devoteeID}&numberOfGuests=${
            res.data.eventGuestCount
          }&hallName=${rowData.priestHallName}&eventTime=${
            res.data.eventStartTime
          }&eventDate=${rowData.bookingDate.split(" ")[0]}&eventType=${
            res.data.eventNature
          }&hallId=${rowData.hallId}&duration=${rowData.timeRequired}&amount=${
            rowData.amount
          }&hallBookingId=${rowData.id}&contractId=${
            rowData.hallContractFormId
          }&STATUS==${rowData.status}`
        );
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const deleteRequestApi = () => {
    setIsLoading(true);
    const reqBody = {
      status: 5,
      cancelReason: reason,
    };
    apiRequest({
      method: "PUT",
      endpoint: `${apiPath.cancelBookingRequest}/${selectedId}`,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setIsLoading(false);
        setSelectedId(null);
        setReason("");
        setOpenCancelDialog(false);
        setDevoteeName("");
        setSelectedTypeName("");
        getApiCall();
        toast.custom(
          <SuccessPopup
            headerMessage="Hall/Priest Schedule"
            showMessage={res?.data}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleProceedCancel = () => {
    deleteRequestApi();
  };

  const handleSelectAll = () => {
    const allSelected = requestData.every((row) =>
      selectedRows.some(
        (selectedRow: poojaHallRentListProps) =>
          selectedRow.devoteeID === row.devoteeID
      )
    );

    if (!allSelected) {
      setSelectedRows([...requestData]);
    } else {
      setSelectedRows([]);
    }
    setButtonDisable(selectedRows.length > 0 ? true : false);
  };

  const handleCheckboxChange = (id: number) => {
    const selectedRow = requestData.find((row) => row.id === id);

    if (selectedRow) {
      if (selectedRows.some((row) => row.id === id)) {
        setSelectedRows((prev) => prev.filter((row) => row.id !== id));
      } else {
        setSelectedRows((prev) => [...prev, selectedRow]);
      }
    }

    // Uncheck "Select All" when any other checkbox is clicked
    if (selectedRows.length === requestData.length && !selectedRow) {
      setSelectedRows([]);
    }
    setButtonDisable(selectedRows.length > 0 ? true : false);
  };

  const handleShowScheduleScreen = () => {
    setShowPriestSchedulingScreen(false);
    setShowHallSchedulingScreen(false);
    getApiCall();
  }

  const onClickLink = (item: poojaHallRentListProps) => {
    if (
      item.status.toLowerCase() === "pending" ||
      item.status === "FORM_SIGNED" ||
      item.status === "BOOKED_PAY_INITIAL_AMOUNT" ||
      item.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" ||
      item.status === "SETTLEMENT_PENDING"
    ) {
      if (!isNil(item.hallContractFormId)) {
        window.location.href = `${ASP_BASE_URL}/hints/manage/content/asp/token_process.asp?priestName=${
          item?.priestHallName
        }&devoteeId=${item?.devoteeID}&dateandtime=${
          item?.bookingDate
        }&location=${item?.location}&poojaName=${item?.poojaName}&username=${
          getUserName() || ""
        }&token=${getaccessToken() || ""}&hallId=${item?.hallId}&requestType=${
          item?.requestType
        }&priestId=${item?.priestId}&poojaId=${item?.poojaId}&timeRequired=${
          item?.timeRequired
        }&status=${item?.status}&id=${
          item?.id
        }&userRoleId=${getUserRoleId()}&contactForm=contactForm`;
      } else {
        if (item?.priestId) {
          const payload = {
            devoteeID: item?.devoteeID,
            priestName: item?.priestHallName,
            priestId: item?.priestId,
            poojaId: item?.poojaId,
            poojaLocation: item?.location === "Temple" ? "TEMPLE_POOJA": "OUTSIDE_POOJA",
            poojaDuration: item?.timeRequired,
            poojaName: item?.poojaName,
            poojaAmount: item?.amount,
            dateOfPooja: separateDateAndTime(item?.bookingDate)?.date,
            poojaTime: separateDateAndTime(item?.bookingDate)?.time,
            isManagerRequest: false,
            poojaHallRequestsId: item?.id,
          }
          dispatch(addPoojaDetails(payload));
          setShowPriestSchedulingScreen(true);
          dispatch(fetchPriestList());
        }else {
          const payload = {
            devoteeID: item?.devoteeID,
            hallName: item?.priestHallName,
            hallId: item?.hallId,
            hallHours: Math.floor(item?.timeRequired / 60),
            hallmins: item?.timeRequired % 60,
            halldesc: "",
            hallAmount: item?.amount,
            date: separateDateAndTime(item?.bookingDate)?.date,
            time: separateDateAndTime(item?.bookingDate)?.time,
            isManagerRequest: false,
            poojaHallRequestsId: item?.id,
          };
          dispatch(addHallBookingDetails(payload));
          setShowHallSchedulingScreen(true);
          dispatch(fetchHallList());
        }
      }
    }
  };

  const handleCancelClick = (bookingInfo: poojaHallRentListProps) => {
    if (bookingInfo.status !== "CANCELLED") {
      setSelectedId(bookingInfo.id);
      setDevoteeName(bookingInfo.devoteeID);
      if (bookingInfo.requestType === "P") {
        setSelectedTypeName(bookingInfo.poojaName);
      } else {
        setSelectedTypeName(bookingInfo.priestHallName);
      }
      setOpenCancelDialog(true);
    } else {
      setOpenCancelDialog(false);
    }
  };

  const handleCancelDialogClose = () => {
    setOpenCancelDialog(false);
    setSelectedId(null);
    setReason("");
    setDevoteeName("");
    setSelectedTypeName("");
  };

  const dialogPopUpComponent = () => {
    return (
      <Dialog
        open={openCancelDialog}
        onClose={handleCancelDialogClose}
        aria-labelledby="cancel-dialog-title"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "574px",
            maxHeight: "300px",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <div
          style={{
            backgroundColor: "#882E14",
          }}
        >
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
          >
            {"Cancel Booking"}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCancelDialogClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 8,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </div>
        <DialogContent>
          <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
            Are you sure you want to cancel {selectedTypeName} for {devoteeName}
            ?
          </Typography>
          <Grid>
            <CustomInputLabel>Reason for Cancellation</CustomInputLabel>
            <Grid xs={12} sm={3} item>
              <TextareaAutosize
                style={{
                  height: "50px",
                  width: "300px",
                  backgroundColor: "#fff9e4",
                  borderRadius: "8px",
                }}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </Grid>
          </Grid>
          <div style={{ float: "right" }}>
            <CommonOutlinedButton
              onClick={handleCancelDialogClose}
              sx={{ marginRight: "10px" }}
            >
              cancel
            </CommonOutlinedButton>
            <CommonButton onClick={handleProceedCancel} disabled={isLoading}>
              {isLoading ? (
                <>
                  <ClipLoader color="#fff" loading={isLoading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                "Yes"
              )}
            </CommonButton>
          </div>
        </DialogContent>
      </Dialog>
    );
  };

  const handleChangeStatus = (e: any) => {
    setStatusValue(e.target.value);
    setPageNumber(1);
    //   const filteredData = requestData.filter((item:poojaHallRentListProps) =>
    //   e.target.value === '' || item.status === e.target.value
    // );
    // console.log(filteredData,"filteredData");
  };

  const handleChangeRequestType = (e: any) => {
    setRequestTypeValue(e.target.value);
    setPageNumber(1);
  };

  const handleChangePageSize = (e: any) => {
    setPageSize(e.target.value);
    setPageNumber(1);
  };

  const handleSubmitReconciliation = () => {
    setShowReconsilation(false);
    getApiCall();
  };

  const handleShowRefundToDevotee = () => {
    setShowRefundToDevotee(false);
    getApiCall();
  };

  const StatusDropdown = (): React.ReactElement => {
    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelectforPooja
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          onChange={handleChangeStatus}
          value={statusValue}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {statusList
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((item: any, i: any) => (
              <CustomMenuItem value={item.id} key={i}>
                {item.label}
              </CustomMenuItem>
            ))}
        </CustomSelectforPooja>
      </FormControl>
    );
  };

  const usernameFilter = () => {
    return (
      <div>
        <CustomInputLabel>Username</CustomInputLabel>
        <CustomTextFeildPooja
          sx={{
            border: "1px solid rgba(136, 46, 20, 0.40)",
            borderRadius: "8px",
          }}
          value={usernameValue}
          onChange={(e: any) => {
            setPageNumber(1);
            setUsernameValue(isEmpty(e.target.value) ? null : e.target.value);
          }}
          placeholder="Enter Username"
        />
      </div>
    );
  };

  const namesFieldFilter = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        <div>
          <CustomInputLabel>Firstname</CustomInputLabel>
          <CustomTextFeildPooja
            sx={{
              border: "1px solid rgba(136, 46, 20, 0.40)",
              borderRadius: "8px",
            }}
            value={firstname}
            onChange={(e) => {
              setPageNumber(1);
              setfirstname(isEmpty(e.target.value) ? null : e.target.value);
            }}
            placeholder="Enter Firstname"
          />
        </div>
        <div>
          <CustomInputLabel>Lastname</CustomInputLabel>
          <CustomTextFeildPooja
            sx={{
              border: "1px solid rgba(136, 46, 20, 0.40)",
              borderRadius: "8px",
            }}
            value={lastname}
            onChange={(e) => {
              setPageNumber(1);
              setLastname(isEmpty(e.target.value) ? null : e.target.value);
            }}
            placeholder="Enter Lastname"
          />
        </div>
      </div>
    );
  };

  const requestTypefilter = (): React.ReactElement => {
    return (
      <FormControl
        className={styles.dropdown}
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelectforPooja
          IconComponent={KeyboardArrowDownIcon}
          displayEmpty
          id="grouped-select"
          onChange={handleChangeRequestType}
          value={requestTypeValue}
          renderValue={
            requestTypeValue !== null
              ? undefined
              : () => <span style={{ color: "black" }}>All</span>
          }
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {requestTypeList.map((item, i: number) => (
            <CustomMenuItem value={item.id} key={i}>
              {item.label}
            </CustomMenuItem>
          ))}
        </CustomSelectforPooja>
      </FormControl>
    );
  };

  const filtersComponent = (): React.ReactElement => {
    return (
      <div className={styles.filterContainer}>
        <div style={{ width: "100%" }}>{usernameFilter()}</div>
        <div style={{ width: "100%" }}>
          <CustomInputLabel>Request Type</CustomInputLabel>
          {requestTypefilter()}
        </div>
        <div style={{ width: "100%" }}>
          <CustomInputLabel>Status</CustomInputLabel>
          {StatusDropdown()}
        </div>
        <div>
          <CustomInputLabel>Items Per Page</CustomInputLabel>
          {itemPerPageDropdown()}
        </div>
      </div>
    );
  };

  const namesfiltersComponent = (): React.ReactElement => {
    return (
      <div style={{ display: "flex", gap: "10px", paddingTop: "20px" }}>
        <div style={{ width: "40%" }}>{namesFieldFilter()}</div>
        <div style={{ width: "20%" }}>
          <CustomInputLabel>Request Type</CustomInputLabel>
          {requestTypefilter()}
        </div>
        <div style={{ width: "20%" }}>
          <CustomInputLabel>Status</CustomInputLabel>
          {StatusDropdown()}
        </div>
        <div style={{ width: "20%" }}>
          <CustomInputLabel>Items Per Page</CustomInputLabel>
          {itemPerPageDropdown()}
        </div>
      </div>
    );
  };

  const itemPerPageDropdown = (): React.ReactElement => {
    return (
      <FormControl
        sx={{
          width: "100%",
          border: "1px solid rgba(136, 46, 20, 0.40)",
          borderRadius: "8px",
        }}
      >
        <CustomSelectforPooja
          IconComponent={KeyboardArrowDownIcon}
          defaultValue=""
          id="grouped-select"
          onChange={handleChangePageSize}
          value={pageSize}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {itemsPerPageList.map((item: number, i: number) => (
            <CustomMenuItem value={item} key={i}>
              {item}
            </CustomMenuItem>
          ))}
        </CustomSelectforPooja>
      </FormControl>
    );
  };

  const statusOnClick = (item: poojaHallRentListProps) => {
    if (
      item.status === "FORM_SIGNED" ||
      item.status === "BOOKED_PAY_INITIAL_AMOUNT" ||
      item.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" ||
      item.status === "FORM_FILLED" ||
      item.status === "FORM_TO_BE_SIGNED"
    ) {
      apiCall(item);
      setShowReconsilation(false);
    } else if (item.status === "SETTLEMENT_PENDING") {
      setHallContractId(item.id);
      setContractId(parseInt(item.hallContractFormId));
      setShowReconsilation(true);
    } else if (
      item.status === constants.HALL_BOOKING_STATUS.AMOUNT_DUE_TO_DEVOTEE
    ) {
      setHallContractId(item.id);
      setContractId(parseInt(item.hallContractFormId));
      setShowRefundToDevotee(true);
      setSelectedHallRequest(item);
    }
  };

  const renderTableComponent = () => {
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                {/* <th className={styles.tableHorizontal}>
                  <div>
                    <CustomCheckbox
                      checked={selectedRows.length === requestData.length}
                      onChange={handleSelectAll}
                    />
                  </div>
                </th> */}
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>Pooja Name</th>
                <th className={styles.tableHorizontal}>Location</th>
                <th className={styles.tableHorizontal}>Date & Time</th>
                <th className={styles.tableHorizontal}>Priest/Hall Name</th>
                <th className={styles.tableHorizontal}>Schedule Pooja/Hall</th>
                <th className={styles.tableHorizontal}>Status</th>
                <th className={styles.tableHorizontal}>Created Date</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {requestData.map((row: poojaHallRentListProps, index) => (
                <tr key={index} className={styles.tableRow}>
                  {/* <td className={styles.tableDiagonal}>
                    <CustomCheckbox
                      checked={selectedRows.some(
                        (selectedRow) => selectedRow.id === row.id
                      )}
                      onChange={() => handleCheckboxChange(row.id)}
                    />
                  </td> */}
                  {/* <td className={styles.tableDiagonal}>{row.id}</td> */}
                  <td
                    className={styles.tableDiagonal}
                    style={{ color: "#F05802", fontWeight: 500 }}
                  >
                    {row?.firstname} {row?.lastname}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ fontWeight: 400 }}
                  >
                    {row?.poojaName}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ fontWeight: 500 }}
                  >
                    {row?.location}
                  </td>
                  <td className={styles.tableDiagonal}>{row?.bookingDate}</td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ color: "#F05802", fontWeight: 400 }}
                  >
                    {row?.priestHallName}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      color: "#F05802",
                      fontWeight: 400,
                      textDecoration:
                        row.status.toLowerCase() === "pending" ||
                        row.status === "FORM_SIGNED" ||
                        row.status === "BOOKED_PAY_INITIAL_AMOUNT" ||
                        row.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" ||
                        row.status === "SETTLEMENT_PENDING"
                          ? "underline"
                          : "",
                      cursor:
                        row.status.toLowerCase() === "pending" ||
                        row.status === "FORM_SIGNED" ||
                        row.status === "BOOKED_PAY_INITIAL_AMOUNT" ||
                        row.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" ||
                        row.status === "SETTLEMENT_PENDING"
                          ? "pointer"
                          : "",
                    }}
                    onClick={() => onClickLink(row)}
                  >
                    {row.status.toLowerCase() === "pending" ||
                    row.status === "FORM_SIGNED" ||
                    row.status === "BOOKED_PAY_INITIAL_AMOUNT" ||
                    row.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" ||
                    row.status === "SETTLEMENT_PENDING"
                      ? "Click here"
                      : "-"}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 700,
                      color:
                        row.status.toLowerCase() === "pending" ||
                        row.status === "CANCEL_REQUEST"
                          ? "#F05802"
                          : "#43A022",
                          cursor:
                        row.status.toLowerCase() === "pending" || row.status === "FORM_FILLED" || row.status === "FORM_SIGNED" || row.status === "BOOKED_PAY_INITIAL_AMOUNT" || row.status === "FINAL_PAYMENT_DUE_AND_CONTRACT" || row.status === "SETTLEMENT_PENDING" || row.status === "FORM_TO_BE_SIGNED" || row.status === "AMOUNT_DUE_TO_DEVOTEE" || row.status === "AMOUNT_DUE_TO_HCCC" || row.status === "CLOSED"  ? "pointer" : ""
                    }}
                    onClick={() => statusOnClick(row)}
                  >
                    {row?.statusDisplayName}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{ fontWeight: 400 }}
                  >
                    {row?.createdDate}
                  </td>
                  <td
                    className={styles.tableDiagonal}
                    style={{
                      fontWeight: 700,
                      color: "#F05802",
                      cursor:
                        row.status.toLowerCase() !== "cancelled"
                          ? "pointer"
                          : "",
                    }}
                    onClick={() => handleCancelClick(row)}
                  >
                    {row.status.toLowerCase() === "cancelled" ? "-" : "Cancel"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const dashBoardComponent = () => {
    return (
      <Box className={styles.DuplicateDevoteeLayout}>
        <Toaster />
        <Typography className={styles.headerTitle}>Devotee Service</Typography>
        <Box className={styles.SubContainer}>
          <Typography className={styles.SubHeading}>
            All Devotee Pooja / Hall Booking Requests
          </Typography>
          {/**
           * Uncomment the below code when it needs
           */}
          {/* <Box sx={{ gap: "1rem", marginLeft: "auto" }}>
          <CommonButton sx={{ margin: "5px" }} disabled={buttonDisable}>
            Confirm
          </CommonButton>
          <CommonButton sx={{ margin: "5px" }} disabled={buttonDisable}>
            Cancel
          </CommonButton>
        </Box> */}

          {/* {filtersComponent()} */}
        </Box>
        {namesfiltersComponent()}
        {totalRecords > 0 ? (
          <>{renderTableComponent()}</>
        ) : (
          <Typography sx={{ textAlign: "center" }}>
            No Records found.
          </Typography>
        )}
        {totalRecords > pageSize ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "20px",
              gap: "10px",
              marginLeft: "auto",
            }}
          >
            <Pagination
              items={totalRecords}
              itemsPerPage={pageSize} // Change this line
              setPageNumber={setPageNumber}
              pageNumber={pageNumber}
            />
          </div>
        ) : (
          ""
        )}
        {dialogPopUpComponent()}
      </Box>
    );
  };

  return (
    <>
      {!showReconsilation && !showRefundToDevotee && !showPriestSchedulingScreen && !showHallSchedulingScreen && dashBoardComponent()}
      {showReconsilation && !showPriestSchedulingScreen && !showHallSchedulingScreen && (
        <FinalSettlementComponent
          hallContractId={hallContractId}
          contractId={contractId}
          handleSubmitReconciliation={handleSubmitReconciliation}
        />
      )}
      {showRefundToDevotee && !showPriestSchedulingScreen && !showHallSchedulingScreen && (
        <RefundToDevotee
          onClose={handleShowRefundToDevotee}
          selectedTable={selectedHallRequest}
        />
      )}
      {showPriestSchedulingScreen && <PriestWeeklySchedule setShowPriestSchedulingScreen={handleShowScheduleScreen}/>}
      {showHallSchedulingScreen && <HallSchedule setShowHallScheduleScreen={handleShowScheduleScreen}/>}
    </>
  );
};

export default DevoteePoojaHallRequest;
